<template>
  <div>
    <h3>批量更新商品详情链接</h3>
    <div>
      <el-button @click="onDownload">下载导入模板</el-button>
      <el-button type="primary" style="position: relative;" :loading="loading">
        <input
          type="file"
          style="position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                opacity: 0;
              "
          @change="onSubmit"
        />
        批量更新
      </el-button>
    </div>
  </div>
</template>

<script>
import { importLinkUrl } from '@/api/goods';
export default {
  name: 'goodsSetting',

  data () {
    return {
      loading: false,
    };
  },

  methods: {
    async onSubmit ($event) {
      this.loading = true;
      try {
        await importLinkUrl($event.target.files[0]);
        this.$message.success('批量更新成功');
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      $event.target.value = '';
    },

    onDownload () {
      window.open('/api/goods/exportLinkUrl');
    },
  },
};
</script>
